import {
  BUSCLS_INIT_LOADING,
  BUSCLS_INIT_SUCCESS,
  BUSCLS_INIT_FAIL,
  BUSCLS_MENU_LOADING,
  BUSCLS_MENU_SUCCESS,
  BUSCLS_MENU_FAIL,
  BUSCLS_COVER_LOADING,
  BUSCLS_COVER_SUCCESS,
  BUSCLS_COVER_FAIL,
  BUSCLS_TARF_LOADING,
  BUSCLS_TARF_SUCCESS,
  BUSCLS_TARF_FAIL,
  BUSCLS_INIT_LIST
} from '@/store/types'
export const busCls = {
  [BUSCLS_INIT_LOADING](state) {
    state.busCls.init = 0
    state.busCls.initErr = []
    state.busCls.menu = {}
  },
  [BUSCLS_INIT_SUCCESS](state, data) {
    state.busCls.init = 1
    state.busCls.initErr = []
    state.busCls.menu = data.menu
  },
  [BUSCLS_INIT_FAIL](state, error) {
    state.busCls.init = 2
    state.busCls.initErr = error
    state.busCls.menu = {}
  },
  [BUSCLS_MENU_LOADING](state) {
    state.busCls.busClsMenu.init = 0
    state.busCls.busClsMenu.initErr = []
    state.busCls.busClsMenu.menu = {}
  },
  [BUSCLS_MENU_SUCCESS](state, data) {
    state.busCls.busClsMenu.init = 1
    state.busCls.busClsMenu.initErr = []
    state.busCls.busClsMenu.busClsTarfList = data.data.busClsTarfList
    state.busCls.busClsMenu.busClsCoverList = data.data.busClsCoverList
    state.busCls.busClsMenu.sideMenuTitle = data.data.busCls.busCls + ' - ' + data.data.busCls.desc
    state.busCls.busClsMenu.menu = data.menu
  },
  [BUSCLS_MENU_FAIL](state, error) {
    state.busCls.busClsMenu.init = 2
    state.busCls.busClsMenu.initErr = error
    state.busCls.busClsMenu.menu = {}
  },
  [BUSCLS_TARF_LOADING](state) {
    state.busCls.tariff.init = 0
    state.busCls.tariff.initErr = []
    state.busCls.tariff.menu = {}
  },
  [BUSCLS_TARF_SUCCESS](state, data) {
    state.busCls.tariff.init = 1
    state.busCls.tariff.initErr = []
    state.busCls.tariff.menu = data.menu
  },
  [BUSCLS_TARF_FAIL](state, error) {
    state.busCls.tariff.init = 2
    state.busCls.tariff.initErr = error
    state.busCls.tariff.menu = {}
  },
  [BUSCLS_COVER_LOADING](state) {
    state.busCls.cover.init = 0
    state.busCls.cover.initErr = []
    state.busCls.cover.menu = {}
  },
  [BUSCLS_COVER_SUCCESS](state, data) {
    state.busCls.cover.init = 1
    state.busCls.cover.initErr = []
    state.busCls.cover.menu = data.menu
  },
  [BUSCLS_COVER_FAIL](state, error) {
    state.busCls.cover.init = 2
    state.busCls.cover.initErr = error
    state.busCls.cover.menu = {}
  },
  [BUSCLS_INIT_LIST](state, data) {
    state.busCls.tariffList = data.data.tariffList
    state.busCls.coverList = data.data.coverList
    state.busCls.vehGrpList = data.data.vehGrpList
  }
}
